import PropTypes from 'prop-types';
import { h } from 'preact';

import Wrapper from '../../1-foundation/wrapper/wrapper';
import BannerMarketing from '../../3-molecules/banner-marketing/banner-marketing';
import SectionDivider from '../../3-molecules/section-divider/section-divider';
import { modifierList } from '../../3-molecules/banner-marketing/props-list';
import { modifierList as iconModifierList } from '../../1-foundation/icons/props-list';
import { modifierList as sectionDividerModifierList } from '../../3-molecules/section-divider/props-list';
import { IconClose } from '../../1-foundation/icons/icons';

const SlimBanner = ({
  href = '#',
  modifiers = [],
  target = '_self',
  onClick,
  onClose,
  sectionDividerModifiers = [],
  imgSrc = '',
  text = '',
  iconsColor,
}) => (
  <SectionDivider modifiers={sectionDividerModifiers}>
    <div className="l-inner-grid">
      <div className="l-inner-grid__main">
        <Wrapper isWrapping className="c-section-divider__banner-marketing-wrapper">
          <BannerMarketing
            tag="a"
            href={href}
            target={target}
            imgSrc={imgSrc}
            text={text}
            modifiers={modifiers}
            onClick={onClick}
            showArrowIcon
            iconsColor={iconsColor}
            role="button"
            aria-label={text}
          />
          {onClose &&
            <button className="c-section-divider__close" type="button" onClick={onClose}>
              <IconClose modifiers={['navigation', 'close', 'xsmall', 'c-medium-light-2']} />
            </button>
          }
        </Wrapper>
      </div>
    </div>
  </SectionDivider>
);

SlimBanner.propTypes = {
  href: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  target: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  sectionDividerModifiers: PropTypes.arrayOf(PropTypes.oneOf(sectionDividerModifierList)),
  imgSrc: PropTypes.string,
  text: PropTypes.string,
  iconsColor: PropTypes.oneOf(iconModifierList),
};

export default SlimBanner;
